import angular from 'angular';

function TelFilter() {
	return function (tel) {
		var len = tel && tel.length;
		if (len !== 10) {
			return tel;
		} else {
			var num = tel.slice(len - 4);
			var city = tel.slice(len - 7, len - 4);
			var region = tel.slice(0, len - 7);
			return region + '-' + city + '-' + num;
		}
	};
}

export default angular.module('filters.telephone', [])
	.filter('tel', TelFilter)
	.name;



// WEBPACK FOOTER //
// ./project/filters/tel.js